import { createSlice } from "@reduxjs/toolkit";

export const AllEstatesListSlice = createSlice({
    name: "allEstatesList",
    initialState: {
        allEstatesList: [],
    },
    reducers: {
        setAllEstatesList: (state, action) => {
            state.allEstatesList = action.payload;
        },
        clearAllEstatesList: (state, action) => {
            state.allEstatesList = [];
        }
    }
})

export const { setAllEstatesList, clearAllEstatesList } = AllEstatesListSlice.actions;

export default AllEstatesListSlice.reducer;